export const nominalUangSakuSpec = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Nominal Uang Saku',
    name: 'nominal_uang_saku',
    type: 'integer',
  },
]
